/** Texte rund um die Synchronisierung (T-04). */
import type { SyncZustand } from '@/modules/sync/syncDienst';

const TABELLEN: Record<string, string> = {
  areas: 'Bereich', events: 'Termin', tasks: 'Aufgabe', projects: 'Projekt', goals: 'Ziel', lifeWheel: 'Lebensrad',
  weeklyReviews: 'Wochenreflexion', habits: 'Gewohnheit', habitEntries: 'Gewohnheit (Tag)', journal: 'Journal',
  accounts: 'Konto', envelopes: 'Budget', transactions: 'Buchung', subscriptions: 'Abo', books: 'Wissen',
  contacts: 'Kontakt', resources: 'Notiz', attachments: 'Anhang', categories: 'Kategorie', savedColors: 'Farbe',
  priorityColors: 'Prioritätsfarbe', subjects: 'Fach', schoolSettings: 'Schuleinstellungen', grades: 'Note',
  studySessions: 'Lernzeit', journalCategories: 'Bewertungskategorie', thoughts: 'Gedanke',
  monthlyReviews: 'Monatsreflexion', focusGoals: 'Fokusziel', reflexionsFragen: 'Frage', terminBestaetigungen: 'Terminbestätigung',
  listen: 'Liste', listenEintraege: 'Listeneintrag', uebungen: 'Übung', trainingsplaene: 'Trainingsplan',
  planEinheiten: 'Trainingseinheit', trainingsprotokolle: 'Trainingsprotokoll', trainingsEinstellungen: 'Trainingseinstellungen',
  koerpergewicht: 'Körpergewicht', muskelgefuehl: 'Muskelgefühl', sportRad: 'Sport-Rad', lebensmittel: 'Lebensmittel',
  rezepte: 'Rezept', speiseplan: 'Speiseplan', planVorlagen: 'Speiseplan-Vorlage', gegessen: 'Gegessen', getraenke: 'Getränk',
  ernaehrungsEinstellungen: 'Ernährungseinstellungen', tagesvorlagen: 'Tagesvorlage', vorlagenEinstellungen: 'Standardwoche',
  journalLayouts: 'Journal-Aufbau', oberflaeche: 'Seitenleiste', papierkorb: 'Papierkorb', papierkorbZeilen: 'Papierkorb (Inhalt)',
};

const FELDER: Record<string, string> = {
  title: 'Titel', name: 'Name', notes: 'Notizen', description: 'Beschreibung', status: 'Status', dueDate: 'Fälligkeit',
  plannedDate: 'Geplant für', start: 'Beginn', end: 'Ende', text: 'Text', priority: 'Priorität', areaId: 'Bereich',
  projectId: 'Projekt', goalId: 'Ziel', order: 'Reihenfolge', done: 'Erledigt', frage: 'Frage', ratings: 'Bewertungen',
};

export const tabellenName = (t: string) => TABELLEN[t] ?? t;
export const feldName = (f: string) => FELDER[f] ?? f;

/** Kurze Anzeige eines gespeicherten Werts. */
export function wertText(v: unknown): string {
  if (v === undefined || v === null || v === '') return '(leer)';
  if (typeof v === 'boolean') return v ? 'ja' : 'nein';
  const s = typeof v === 'string' ? v : JSON.stringify(v);
  return s.length > 80 ? `${s.slice(0, 79)}…` : s;
}

/** „gerade eben“, „vor 3 Min.“, „vor 2 Std.“, „vor 4 Tagen“. */
export function vorText(iso: string | null, jetzt = Date.now()): string {
  if (!iso) return 'noch nie';
  const min = Math.max(0, Math.round((jetzt - Date.parse(iso)) / 60_000));
  if (min < 1) return 'gerade eben';
  if (min < 60) return `vor ${min} Min.`;
  const std = Math.round(min / 60);
  if (std < 24) return `vor ${std} Std.`;
  const tage = Math.round(std / 24);
  return `vor ${tage} ${tage === 1 ? 'Tag' : 'Tagen'}`;
}

export function statusText(zustand: SyncZustand, zuletzt: string | null, fehler: string | null, jetzt = Date.now()): string {
  switch (zustand) {
    case 'aus': return 'Synchronisierung ist aus';
    case 'laeuft': return 'Wird abgeglichen …';
    case 'offline': return `Offline – Änderungen werden später übertragen (zuletzt abgeglichen ${vorText(zuletzt, jetzt)})`;
    case 'fehler': return `Fehler: ${fehler ?? 'unbekannt'}`;
    case 'bereit': return `Zuletzt abgeglichen ${vorText(zuletzt, jetzt)}`;
  }
}
